var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invest-row-wrap",style:('background:' + _vm.bg)},[_c('div',{staticClass:"tit"},[_c('div',[_vm._t("title")],2)]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }